import React, { useEffect, useState } from 'react'
import { StatisticsWidget5 } from '../../../../_metronic/partials/widgets/statistics/StatisticsWidget5'
import { TwoY_AxisChart } from '../../../../_metronic/partials/widgets/chartsComponents/TwoY_AxisChart'
import { ListsWidget6 } from '../../../../_metronic/partials/widgets/lists/ListsWidget6'
// import { Carousel } from 'react-bootstrap-v5'
import { useAuth } from '../../../contexts/CustomContextHook/useAuth'
import axios from 'axios'
import { API_URL } from '../../../modules/Department/DepartmentService'
import FullPageLoader from '../../../modules/FullPageLoader'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import CarouselComponent from './CarouselComponent'
import { useHotel2 } from '../../../contexts/HotelContext'

const DashboardComponentSlider = () => {


    let initialValues = [{
        numberOfEmployees: 0,
        hotelName: '',
        totalSundriesShopProductsSales: 0,
        expiredSundriesShopProducts: 0,
        totalRoomsCleaned: 0,
        totalRoomsSold: 0,
        totalLinenInventoriesToBOrdered: 0,
        twoMonthsWeeksArray: [''],
        lastSevenWeeksTotalPayrollsList: [],
        lastSevenWeeksMPORList: []
    }]



    const [dashboardData, setDashboardData] = useState([]);




    const { UserToken, setUserToken } = useAuth();

    var loggedInUserId = UserToken.LoggedInUserId;

    // console.log('loggedInUserId ((***))== ', loggedInUserId);

    const [loading, setLoading] = useState(false)

    const { HotelId, setHotelId, HotelName, setHotelName } = useHotel2();



    useEffect(() => {

        setHotelId("0");
        setHotelName("");


    }, [])


    useEffect(() => {

        (async () => {


            if (!dashboardData.length) {

                setLoading(true);
                await axios.get(`${API_URL}/api/Dashboard/DashboardDataByUserId?userId=${loggedInUserId}`,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + UserToken.token
                        }
                    })
                    .then(res => {
                        setLoading(false);

                        console.log('Response of DashboardDAta by userId == ', res.data);
                        setDashboardData(res.data);

                    })
                    .catch(err => {
                        setLoading(false);
                    })
            }
        })()


        // return (() => {
        //     setLoading(false);
        //     setDashboardData([]);
        // })


    }, [dashboardData])








    return (
        <>

            {loading &&
                <FullPageLoader />
            }
            {/* {dashboardData  &&
                <Carousel showThumbs={false} showStatus={false} useKeyboardArrows={true}>



                    {dashboardData.map((dashboardDataObj, index) => (


                        <div className='card bg-white' key={index} style={{ marginRight: 28, marginLeft: 28 }}>
                            <div className='row g-5 g-sm-4' key={index + 1}>


                                <div className='col-sm-3'>
                                    <StatisticsWidget5
                                        className='card-xl-stretch mb-xl-8 rounded'
                                        svgIcon='/media/icons/duotune/hotelRooms/door.svg'
                                        color='success'
                                        iconColor='white'
                                        title={dashboardDataObj.hotelName}
                                        description='Hotel Name'
                                    />

                                </div>

                                <div className='col-sm-3'>
                                    <StatisticsWidget5
                                        className='card-xl-stretch mb-xl-8 rounded'
                                        svgIcon='/media/icons/duotune/general/gen049.svg'
                                        color='warning'
                                        iconColor='white'
                                        title={dashboardDataObj.numberOfEmployees}
                                        description='Employees Count'
                                    />
                                </div>

                                <div className='col-sm-3'>
                                    <StatisticsWidget5
                                        className='card-xl-stretch mb-5 mb-xl-8 rounded'
                                        svgIcon='/media/icons/duotune/general/gen032.svg'
                                        color='info'
                                        iconColor='white'
                                        title={dashboardDataObj.totalSundriesShopProductsSales}
                                        description='Sundries Shop Sales'
                                    />
                                </div>

                                <div className='col-sm-3'>
                                    <StatisticsWidget5
                                        className='card-xl-stretch mb-xl-8 rounded'
                                        svgIcon='/media/icons/duotune/general/gen027.svg'
                                        color='primary'
                                        iconColor='white'
                                        title={dashboardDataObj.expiredSundriesShopProducts}
                                        description='Expired Sundries Products'
                                    />
                                </div>

                            </div>

                            <div className='row'>

                                <div className='col-xl-8 col-md-6 col-sm-12' key={Math.random()}>


                                    <TwoY_AxisChart
                                        ChartTitle={'MPOR and Payrolls By every two weeks Graph'}
                                        // XAxislabels={datesList}
                                        XAxislabels={dashboardDataObj.fourMonthsWeeksArray}

                                        Dataset_1_Title={'MPOR (minutes)'}
                                        Dataset_2_Title={'Payrolls ($s)'}
                                        Dataset_1_Array={dashboardDataObj.lastSevenWeeksMPORList}
                                        Dataset_2_Array={dashboardDataObj.lastSevenWeeksTotalPayrollsList}
                                    />
                                </div>
                                <div className='col-xl-4 col-md-6 col-sm-12' key={Math.random()}>
                                    <ListsWidget6 className='card-xl-stretch mb-xl-8'

                                        value1={dashboardDataObj.totalRoomsCleaned}
                                        value2={dashboardDataObj.totalRoomsSold}
                                        value3={dashboardDataObj.totalLinenInventoriesToBOrdered}
                                        value4='test Value'
                                        label1={'Rooms Cleaned(Payroll Report)'}
                                        label2='Rooms Sold(Payroll Report)'
                                        label3='Linen Inventory Items To be Ordered'
                                        label4='test Label'
                                    />
                                </div>


                            </div>

                        </div>
                    ))}

                </Carousel>
            } */}

            {dashboardData ?
                <CarouselComponent dashboardData={dashboardData} />
                : ''}


        </>
    )
}

export default DashboardComponentSlider
